import { createContext, useContext, ReactNode } from "react";
import { useWelcomeState } from "../hooks/useWelcomeState";

const WelcomeContext = createContext<ReturnType<typeof useWelcomeState> | null>(
  null
);

export const useWelcome = () => {
  const context = useContext(WelcomeContext);
  if (!context) {
    throw new Error("useWelcome must be used within a WelcomeProvider");
  }
  return context;
};

export const WelcomeProvider = ({ children }: { children: ReactNode }) => {
  const welcome = useWelcomeState();
  return (
    <WelcomeContext.Provider value={welcome}>
      {children}
    </WelcomeContext.Provider>
  );
};
